import { c as _c } from "react/compiler-runtime";
import type { ApiXTdhContribution } from "@/generated/models/ApiXTdhContribution";
import { InlineRetry, ListError, ListMessage } from "../../subcomponents/XtdhTokensFallbacks";
import { XtdhTokensSkeleton } from "../../subcomponents/XtdhTokensSkeleton";
import { TOKEN_CONTRIBUTORS_GROUP_BY_LABELS, type XtdhTokenContributorsGroupBy } from "@/components/xtdh/received/constants";
import { useXtdhTokenContributorsListState } from "../hooks/useXtdhTokenContributorsListState";
import { XtdhTokenContributorsListItem } from "./XtdhTokenContributorsListItem";
interface XtdhTokenContributorsListProps {
  readonly contributors: ApiXTdhContribution[];
  readonly groupBy: XtdhTokenContributorsGroupBy;
  readonly isEnabled: boolean;
  readonly isLoading: boolean;
  readonly isError: boolean;
  readonly errorMessage?: string | undefined;
  readonly onRetry: () => void;
  readonly onSelectGrant: (grantId: string, label: string) => void;
}
export function XtdhTokenContributorsList(t0) {
  const $ = _c(29);
  const {
    contributors,
    groupBy,
    isEnabled,
    isLoading,
    isError,
    errorMessage,
    onRetry,
    onSelectGrant
  } = t0;
  let t1;
  if ($[0] !== contributors || $[1] !== isEnabled || $[2] !== isError || $[3] !== isLoading) {
    t1 = {
      contributors,
      isEnabled,
      isLoading,
      isError
    };
    $[0] = contributors;
    $[1] = isEnabled;
    $[2] = isError;
    $[3] = isLoading;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    isDisabled,
    showInitialLoading,
    showInitialError,
    showEmptyState,
    hasContributors
  } = useXtdhTokenContributorsListState(t1);
  if (isDisabled) {
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <ListMessage>Unable to load contributors for this token. Please try again later.</ListMessage>;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  if (showInitialLoading) {
    let t2;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <XtdhTokensSkeleton />;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    return t2;
  }
  if (showInitialError) {
    const t2 = errorMessage ?? "Failed to load contributors.";
    let t3;
    if ($[7] !== onRetry || $[8] !== t2) {
      t3 = <ListError message={t2} onRetry={onRetry} />;
      $[7] = onRetry;
      $[8] = t2;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    return t3;
  }
  if (showEmptyState) {
    const t2 = TOKEN_CONTRIBUTORS_GROUP_BY_LABELS[groupBy];
    let t3;
    if ($[10] !== t2) {
      t3 = t2.toLowerCase();
      $[10] = t2;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    let t4;
    if ($[12] !== t3) {
      t4 = <ListMessage>No {t3} data was returned for this token.</ListMessage>;
      $[12] = t3;
      $[13] = t4;
    } else {
      t4 = $[13];
    }
    return t4;
  }
  let t2;
  if ($[14] !== contributors || $[15] !== onSelectGrant) {
    let t3;
    if ($[17] !== onSelectGrant) {
      t3 = (contribution, index) => {
        const key = contribution.grant?.id ?? contribution.grantor?.id ?? index;
        return <XtdhTokenContributorsListItem key={key} contribution={contribution} onSelectGrant={onSelectGrant} />;
      };
      $[17] = onSelectGrant;
      $[18] = t3;
    } else {
      t3 = $[18];
    }
    t2 = contributors.map(t3);
    $[14] = contributors;
    $[15] = onSelectGrant;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  let t3;
  if ($[19] !== t2) {
    t3 = <ul className="tw-m-0 tw-flex tw-flex-col tw-gap-3 tw-p-0">{t2}</ul>;
    $[19] = t2;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  let t4;
  if ($[21] !== errorMessage || $[22] !== hasContributors || $[23] !== isError || $[24] !== onRetry) {
    t4 = isError && hasContributors ? <InlineRetry message={errorMessage ?? "Unable to load more contributors."} onRetry={onRetry} /> : null;
    $[21] = errorMessage;
    $[22] = hasContributors;
    $[23] = isError;
    $[24] = onRetry;
    $[25] = t4;
  } else {
    t4 = $[25];
  }
  let t5;
  if ($[26] !== t3 || $[27] !== t4) {
    t5 = <div className="tw-space-y-3">{t3}{t4}</div>;
    $[26] = t3;
    $[27] = t4;
    $[28] = t5;
  } else {
    t5 = $[28];
  }
  return t5;
}